import * as _ from "lodash";
import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";

let EffortTypesListComponent = {
    selector: "vcEffortTypesList",
    templateUrl: "/angular/components/effort/effort-types-list.component.html",
    bindings: {
        selectedTypes: "=?",
        selectedType: "=?",
        allowMultiple: "=?",
    },
    controller: class EffortTypesListController {
        // * bindings for typescript compiler *
        public selectedTypes?: any;
        public selectedType?: any;
        public allowMultiple?: any;
        // ************************************

        private effortTypes: object[];
        private effort: Effort;

        private dialog: DialogUtils;
        private dataProvider: EffortDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            EffortDataProvider: EffortDataProvider
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = EffortDataProvider;

            this.effortTypes = _.cloneDeep(this.dataProvider.types);
        }

        selectType(type: any): void {
            if (!this.allowMultiple) {
                angular.forEach(this.effortTypes, (effortType: any) => {
                    effortType.selected = false;
                });

                this.selectedType = type;
                type.selected = true;
            } else {
                type.selected = !type.selected;
                this.selectedTypes.splice(0, this.selectedTypes.length);
                angular.forEach(this.effortTypes, (effortType: any) => {
                    if (effortType.selected) {
                        this.selectedTypes.push(effortType);
                    }
                });
            }
        }

        submit(): void {
            this.effort.type = "survey";
            if (!this.effort.id) {
                this.dataProvider
                    .createEffort(this.effort)
                    .then((effort: object) => {
                        this.dialog.hide(effort);
                    });
            } else {
                this.dataProvider
                    .updateEffort(this.effort)
                    .then((effort: object) => {
                        this.dialog.hide(effort);
                    });
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("effort")
    .component(EffortTypesListComponent.selector, EffortTypesListComponent);
